import {createContext, useContext} from 'react';
import {UserDocument} from '../UserDocument';

export const CurrentUserContext = createContext<UserDocument | undefined>(undefined);

export function useOptionalCurrentUser(): UserDocument | undefined {
  return useContext(CurrentUserContext);
}
